import { DialogConfig, DialogRef, DialogRole } from '@angular/cdk/dialog';
import { ComponentType } from '@angular/cdk/portal';
import { Component, EventEmitter, Injectable, OnDestroy, Output } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { BehaviorSubject, Observable, of, Subject } from 'rxjs';
import { PopupItem } from 'src/app/common/services/popup/popup-item';
import { ProductSelectionControlComponent } from 'src/app/foundation/product-selection-control/product-selection-control.component';
import { RemarksControlComponent } from 'src/app/foundation/remarks-control/remarks-control.component';
import { COBProductSelectionFormComponent } from 'src/app/rcob/cob-product-selection-form/cob-product-selection-form.component';
import { AlertDialogComponent } from '../../dialogs/alert-dialog/alert-dialog.component';
import { ConfirmationDialogComponent } from '../../dialogs/confirmation-dialog/confirmation-dialog.component';
import { ResultPageComponent } from 'src/app/process-shell/result-page/result-page.component';
import { FilePreviewComponent } from 'src/app/rcob/file-preview/file-preview.component';
import { ChooseFileUploadComponent } from 'src/app/common/components/choose-file-upload/choose-file-upload.component';
import { SimpleSelfieCaptureComponent } from 'src/app/rcob/simple-selfie-capture/simple-selfie-capture.component';

@Injectable({
  providedIn: 'root',
})
export class DialogService {

  defaultDialogData: CBXDialogData = {
    title: 'Done',
    message: 'Successfully completed',
    button: ['Close']
  }

  defaultDialogOptions: CBXDialogOptions = {
      component: 'alert',
      data: this.defaultDialogData,
      width: '100%',
      hasBackdrop: true,
      panelClass: 'alert-dialog',
      backdropClass: 'alert-dialog-backdrop',
      disableClose: false
  }
  readonly afterAllClosed: Observable<void>;

  constructor(private _dialog: MatDialog) {}

  open(dialogOptions: CBXDialogOptions){
    this._dialog.open(this.getComponent(dialogOptions.component), {
    ... this.defaultDialogOptions,
    ... dialogOptions
    }).afterClosed().subscribe(
      (action)=> {
        if (action) return dialogOptions.closeFn(action);
        else return dialogOptions.closeFn();
      }
    );
    // return this.cBXMatDialogRef
  }

  getComponent(path): ComponentType<any> {
    let component: ComponentType<any>;
    switch (path) {
      case 'alert': component = AlertDialogComponent; break;
      case 'confirmation': component = ConfirmationDialogComponent; break;
      case 'result': component = ResultPageComponent; break;
      case 'filePreview': component = FilePreviewComponent; break;
      case 'chooseFileUpload': component = ChooseFileUploadComponent; break;
      case 'simplecamera': component = SimpleSelfieCaptureComponent;break;
    }
    return component;
  }

  getPopup(path) {
    let children: PopupItem;
    switch (path) {
      // case 'CHQBKREQ':
      //   children = new PopupItem(AccChequeBookRequestFormComponent, {});
      //   break;
    }

    return children;
  }


}

export class CBXDialogOptions extends MatDialogConfig {
  result?: 'success' | 'failure' | 'warning';
  component?: string = 'alert | confirmation';
  data?: CBXDialogData;
  closeFn?: any;
}

export class CBXDialogData {
  title?: string;
  message?: string;
  refNum?: string;
  button?: any[];
  files?: File[];
  data?: any;
  icon?:string;
  okLabel?:string ;
  cancelLabel?:string ;
  min?:string;
  redirect?:string;
}
// @Component({
//   template: ''
// })
// export class CBXMatDialogRef {
//   constructor() {}
//   // @Output() close: EventEmitter<any>;
//   @Output("close") close: EventEmitter<boolean> = new EventEmitter<boolean>();

//   afterClosed() {
//     // this.close = new EventEmitter();
//     return this.close;
//   }

// }
